<div
  *ngIf="viewModel$ | async as vm"
  class="card d-flex flex-column flex-grow-1"
  style="width: 90%"
>
  <div class="card-body d-flex flex-column flex-grow-1">
    <div style="height: 90px">
      <div class="d-flex justify-content-center mt-1">
        {{ vm.message }}
      </div>
      <div class="d-flex justify-content-center">
        <div class="col-6 align-items-center mt-1" *ngIf="vm.oncall">
          <ngb-progressbar type="success" [value]="vm.progress" height="2em">
            Loading
          </ngb-progressbar>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center mt-3">
      <button
        type="button"
        style="width: 8em"
        class="btn btn-secondary btn-small"
        [disabled]="!vm.continue || vm.submitting"
        (click)="this.continue()"
      >
        Continue
      </button>
    </div>
    <div class="d-flex justify-content-center mt-2">
      <button
        type="button"
        style="width: 8em"
        class="btn btn-secondary btn-small"
        (click)="this.cancel($event)"
        [disabled]="vm.oncall || vm.submitting"
      >
        Cancel
      </button>
    </div>
    <div class="d-flex justify-content-center mt-2">
      <button
        style="width: 8em"
        type="button"
        class="btn btn-secondary btn-small"
        [hidden]="!vm.fastVoicemail"
        [disabled]="
          !vm.fastVoicemail || !vm.oncall || vm.progress >= 90 || vm.submitting
        "
        (click)="this.fastvoicemail($event)"
      >
        Voicemail
      </button>
    </div>
    <div class="d-flex justify-content-center mt-2">
      <button
        type="button"
        style="width: 8em"
        class="btn btn-secondary btn-small"
        [disabled]="!vm.oncall || vm.submitting"
        [hidden]="!vm.fastVoicemail"
        (click)="this.person($event)"
      >
        Person
      </button>
    </div>
  </div>
</div>
